/**
 * TikTok Pixel helpers.
 *
 * Wraps window.ttq.track() so calls are safe to make even before the pixel
 * script loads (or in environments where it's absent, e.g. localhost).
 *
 * Deduplication: pass event_id matching the server-side Events API call so
 * TikTok counts the event once even though it arrives from both browser and server.
 */

/**
 * Fire a TikTok pixel event.
 *
 * @param {string} event     - TikTok event name, e.g. "InitiateCheckout"
 * @param {object} props     - Event properties (value, currency, contents, …)
 * @param {string} [eventId] - Optional dedup ID — use reservation_id to match server events
 */
export function ttqTrack(event, props = {}, eventId) {
  try {
    if (typeof window === "undefined" || !window.ttq) return;
    if (eventId) {
      window.ttq.track(event, props, { event_id: String(eventId) });
    } else {
      window.ttq.track(event, props);
    }
  } catch {
    // Never let pixel errors surface to the user
  }
}
